import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Button, makeStyles } from "@material-ui/core";
import { ArrowRight as ArrowRightIcon } from "@material-ui/icons";

const useMultiTraffickStyles = makeStyles((theme) => ({
  link: { textDecoration: "none", color: "black" }
}));

const checkCompatibility = (arrayToCheck, compatibility) => {
  return [...arrayToCheck].every(
    (item) => item.compatibility === compatibility
  );
};

export const MultiTraffickButton = ({
  selectedPlacements,
  isAddingCreativeAllowed,
  onSubmit
}) => {
  const classes = useMultiTraffickStyles();

  const [creativeTypeText, setCreativeTypeText] = useState("Add ...");
  const [routeName, setRouteName] = useState("/");
  const placementInfoData = useSelector((state) => state.placementInfo);

  useEffect(() => {
    let dcmSelectedPlacementIds = selectedPlacements.map(
      (dcmPlacement) => dcmPlacement.id
    );

    let sqlSelectedPlacements = Object.values(
      placementInfoData.byId
    ).filter((placementInfo) =>
      dcmSelectedPlacementIds.includes(placementInfo.Placement_Id)
    );

    let addText = "Add ...";
    let route = "/";

    if (checkCompatibility(selectedPlacements, "DISPLAY")) {
      addText = "Add Static/H5/RM";
      route = "/display";
    }

    if (checkCompatibility(selectedPlacements, "IN_STREAM_VIDEO")) {
      addText = "Add Video";
      route = "/video";
    }

    if (checkCompatibility(selectedPlacements, "IN_STREAM_AUDIO")) {
      addText = "Add Audio";
      route = "/audio";
    }

    if (
      sqlSelectedPlacements.every(
        (sqlPlacement) => sqlPlacement.Serving_Type === "Site"
      )
    ) {
      addText = "Add Site Served";
      route = "/siteserved";
    }

    setRouteName(route);
    setCreativeTypeText(addText);
  }, [selectedPlacements, placementInfoData.byId]);

  return (
    <Link className={classes.link} to={routeName}>
      <Button
        variant="contained"
        color="secondary"
        aria-label="add"
        disabled={!isAddingCreativeAllowed}
        endIcon={<ArrowRightIcon />}
        disableElevation
        onClick={onSubmit}
      >
        {creativeTypeText}
      </Button>
    </Link>
  );
};
